// extracted by mini-css-extract-plugin
export default {"meeting_title":"styles_meeting_title__nJO7H","review_meeting":"styles_review_meeting__U0DVI","date_wrapper":"styles_date_wrapper__vurDp","date":"styles_date__sHzIL"};